class DrawerProductReviews extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.mutationObserver = new MutationObserver(() => this.adoptModal())
  }

  setupListeners () {
    super.setupListeners()

    this.handleDrawerChange = this.handleDrawerChange.bind(this)
    this.handleDrawerClose = this.handleDrawerClose.bind(this)
    this.handleDrawerCancel = this.handleDrawerCancel.bind(this)
    this.handleModalEvent = this.handleModalEvent.bind(this)

    this.listeners.add(document, 'drawer-changed', this.handleDrawerChange)
    this.listeners.add(this.drawer, 'close', this.handleDrawerClose)
    this.listeners.add(this.drawer, 'cancel', this.handleDrawerCancel)
  }

  handleDrawerChange () {
    if (!this.drawer.isOpen) return

    this.mutationObserver.observe(document.body, { childList: true })
    this.adoptModal()
  }

  handleDrawerClose () {
    this.mutationObserver.disconnect()

    if (this.modal?.parentElement !== this.drawer) return

    this.listeners.remove('click', this.handleModalEvent)
    this.listeners.remove('keydown', this.handleModalEvent)

    document.body.append(this.modal)
  }

  handleDrawerCancel (event) {
    if (!this.modalIsOpen) return

    event.preventDefault()
  }

  handleModalEvent (event) {
    if (event.type === 'keydown' && event.key !== 'Escape') return

    event.stopPropagation()
  }

  adoptModal () {
    if (!this.modal || this.modal.parentElement === this.drawer) return

    this.listeners.add(this.modal, 'click', this.handleModalEvent)
    this.listeners.add(this.modal, 'keydown', this.handleModalEvent)

    this.drawer.append(this.modal)
  }

  get drawer () {
    return this.closest('[is="site-drawer"]')
  }

  get modal () {
    return document.getElementById('oke-modalContainer')
  }

  get modalIsOpen () {
    return Boolean(this.modal?.querySelector('.oke-modal'))
  }
}

if (!customElements.get('drawer-product-reviews')) {
  customElements.define('drawer-product-reviews', DrawerProductReviews)
}
